<template>
  <div id="app">
    <!--头部-->
    <header-nav></header-nav>
    <!--头部导航-->
    <nav-bar></nav-bar>
    <keep-alive>
      <router-view  v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />

    <!--底部-->
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import HeaderNav from './components/HeaderNav'
import NavBar from './components/NavBar'
import FooterNav from './components/FooterNav'
export default {
  name: 'App',
  created() {
    let mobile = localStorage.getItem('userInfo')
    let sessionId = localStorage.getItem('sessionId')
    let invoiceMoney = localStorage.getItem('invoiceMoney')
    if (sessionId) {
      this.$store.dispatch('recordUserBaseInfo')
    }
  },
  components: {
    HeaderNav,
    NavBar,
    FooterNav
  }
}
</script>

<style lang="less" type="text/less">
#app {
  font-family: PingFang-SC-Regular;
  button{
    &:focus{
      outline: 0;
    }
  }
  input{
    &:-webkit-autofill {
      -webkit-text-fill-color: #333 !important; /*浏览器记住密码的字的颜色*/
      transition: background-color 5000s ease-in-out 0s; /*通过延时渲染背景色变相去除背景颜色*/
      caret-color: #333; /*光标颜色*/
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue